import Swiper from "swiper";
import Countdown from "jquery-countdown"

"use strict";

// jquery много не бывает...



$(document).ready(function () {




    // инициализируем свайпер
    let gallery = new Swiper ('.product-gallery', {
        loop: true,

        pagination: {
            el: '.product-gallery__pagination',
            clickable: true,
            dynamicBullets: true,
        },
        navigation: {
            nextEl: '.product-gallery__next',
            prevEl: '.product-gallery__prev',
        },
        effect: 'fade',
        fadeEffect: { crossFade: true },
        breakpoints: {
            767: {
                pagination: {
                    dynamicBullets: false,
                },
            },
        }
    })


    const gallerySizeSquad = () => {
        const gallerySize = $(".product-gallery__wrap").width()
        $(".product-gallery__wrap").css("height", gallerySize)
    }
    $(window).resize(() => {
        gallerySizeSquad()
    });
    gallerySizeSquad()


    const moveProductHeader = () => {
        const productHeader = $(".product__header:first")
        if ( $(window).width() < 768) {
            productHeader.prependTo(".product-wrap__left")
        } else {
            productHeader.prependTo(".product__content")
        }
    }
    $(window).resize(() => {
        moveProductHeader()
    });
    moveProductHeader()




    const timer = $('.timer')
    let timer2 = "28:44"
    let oldTimer = localStorage.getItem('time')
    if (oldTimer !== null && oldTimer >= "00:00" ) { timer2 = oldTimer }
    else if (oldTimer <= "00:00") {
        timer2 = "28:44"
        localStorage.setItem('time', "28:44")
    }

    const interval = setInterval(() => {
        const timer = timer2.split(':')
        let minutes = parseInt(timer[0], 10)
        let seconds = parseInt(timer[1], 10)
        --seconds
        minutes = (seconds < 0) ? --minutes : minutes
        if (minutes < 0) clearInterval(interval)
        seconds = (seconds < 0) ? 59 : seconds
        seconds = (seconds < 10) ? '0' + seconds : seconds
        $('.timer__value--h').html("00")
        $('.timer__value--m').html(minutes)
        $('.timer__value--s').html(seconds)
        timer2 = minutes + ':' + seconds
        if (timer2 <= "00:00") {
            $(".timer").css("color", "red")
            $('.timer__value--m, .timer__value--s').html("00")
        }
        localStorage.setItem('time', timer2)
    }, 1000)

    setTimeout(()=> {
        timer.css('opacity', '1')
    }, 1000)

    // запускаем видео по кнопке
    $('.video-section__play-button').on('click', function () {
        $(this).addClass("animation_play");
        $(".video-section__cover").fadeOut(750);
        $('#default_video').get(0).play();
    });

    $('.product-gallery__next, .product-gallery__prev').on('click', function () {
        $('#default_video').get(0).pause();

    });

    let video_cover = $(".video-section__cover").attr('data-video_cover');
    $('.video-section__cover').css('background-image', 'url(' + video_cover + ')');


    const changePercent = (variations) => {
        let percent = ""
        switch (String(variations[0])) {
            case "200000183:3":
                if (quantityDefault) {
                    percent = "60"  // скидка за двойной товар (лэфт + райт)
                } else {
                    percent = quantityChangedValue
                }
                break;
            default:
                if (quantityDefault) {
                    percent = "60"  // скидка на лефт/райт
                } else {
                    percent = quantityChangedValue
                }
        }
        return percent
    }

    const percentType = (variations) => {
        let progressivePercent = false
        switch (String(variations[0])) {
            case "200000183:3":
                progressivePercent = true
                break;
            default:
                progressivePercent = false
        }
        return progressivePercent
    }

    const changePrice = (variations) => {
        let price = ""
        switch (String(variations[0])) {
            case "200000183:3":
                price = "116"
                break;
            default:
                price = "58"
        }
        return price
    }




    // создаем пустой массив для вариаций и считаем количество наборов вариаций (цвета, размеры, доставка, etc..)
    let variations = []
    let variationsName = []
    let variationsCount = $(".product").first().find(".product-variations").length

    // заполняем массив вариаций выбранными по умолчанию аттрибутами
    $(".product .product-variations__active").each(function (i) {
        if (i < variationsCount) {
            variations.push($(this).attr("data-sku-set"))
            variationsName.push($(this).find("[data-value]").attr("data-value"))
        }
    })
    console.log(variations)

    // создаем переменнную порядкового номера продукта с которым работаем (на странице может быть несколько дублирующихся продуктов)
    let activeProductNum = 0




    let quantityDefault = true
    let quantityChangedValue = ""
    $(document.body).on("click", ".quantityList-item", function () {
        $(this).parent().find(".quantityList-item__active").removeClass("quantityList-item__active")
        $(this).toggleClass("quantityList-item__active")
        const quantityCount = $(this).index()
        $(".product-controls__quantity").find(".js-quantity_input").val(quantityCount)

        const quantityPercent = $(this).find(".js-variation-sale").html()
        $("body").find(".js-percent").html(quantityPercent)
        quantityDefault = false
        quantityChangedValue = quantityPercent

    })

    const quantityList = (activePrice, activePercent, progressivePercent) => {

            $('.quantityList-item').each(function (index) {
                const variationsNamesFormat = variationsName.map(item => ' ' + item)
                $(this).find(".js-variation-name").html(String(variationsNamesFormat))

                    let ppPercent = "50"

                    switch (index) {
                        case 2:
                            ppPercent = "55"
                            break;
                        case 3:
                            ppPercent = "60"
                            break;
                        case 4:
                            ppPercent = "65"
                            break;
                        case 5:
                            ppPercent = "70"
                            break;
                    }

                    $(this).find(".js-variation-sale").html(ppPercent)

                    let ppSumPrice = activePrice * index
                    let ppPercentValue = decPercent(ppSumPrice, ppPercent)
                    ppSumPrice = ppSumPrice - ppPercentValue
                    $(this).find(".js-variation-sumPrice").html(ppSumPrice.toFixed(2))

                    let ppUnitPrice = ppSumPrice / index
                    ppUnitPrice = progressivePercent ? ppUnitPrice / 2 : ppUnitPrice
                    $(this).find(".js-variation-unitPrice").html(ppUnitPrice.toFixed(2))

            })


    }



    const decPercent = (dpValue, dpPercent) => {
        const dpPercentValue = dpValue - (dpValue / 100 * dpPercent)
        const dpResult = dpValue - dpPercentValue
        console.log(dpResult)
        return dpResult
    }



    // отслеживаем клик по аттрибуту
    $(document.body).on("click", ".product-variations__item", function() {

        let thisProduct = $(this).closest(".product")

        // добавляем класс для выбранного аттрибута
        $(this).parent().find(".product-variations__active").removeClass("product-variations__active")
        $(this).toggleClass("product-variations__active")

        // если аттриубт является картинкой
        if ($(this).hasClass("variation-image")) {
            $('#default_video').get(0).pause();
            const activeAttrImg = $(this).find("[data-img]").attr("data-img")

            const refreshGallery = () => {
                $(".product-gallery__slide.swiper-slide-active").find("img").attr("src", activeAttrImg)
                $(".product-gallery").css("opacity", "1")
            }

            if ($(".product-gallery__slide.swiper-slide-active").hasClass("product-gallery__slide--video")) {
                $(".product-gallery").css("opacity", "0")
                gallery.slideNextTransitionStart
                setTimeout(refreshGallery, 500)
            } else {
                setTimeout(refreshGallery, 0)
            }

            if ($('.product-gallery').length > 1) {
                $('.product-gallery').each(function(index) {
                    gallery[index].slideToLoop(1);
                })
            } else {
                gallery.slideToLoop(1);
            }
        }

        // получаем порядковый номер продукта на странице
        activeProductNum = $(".product").index(thisProduct)

        // получаем и выводим value выбранного аттрибута
        const activeAttrValue = $(this).find("[data-value]").attr("data-value")
        $(this).parent().prev().find(".product-variations__data-value").html(activeAttrValue);

        // чистим наш массив вариаций и вставляем туда новые
        variations = []
        variationsName = []
        thisProduct.find(".product-variations__active").each(function (i) {
            variations.push($(this).attr("data-sku-set"))
            if (i < 1) {
                variationsName.push($(this).find("[data-value]").attr("data-value"))
            }

        })

        console.log(variations)

        const activePrice = changePrice(variations)
        const activePercent = changePercent(variations)
        const progressivePercent = percentType(variations)

        quantityList(activePrice, activePercent, progressivePercent)


        $("body").find(".js-percent").html(activePercent)

        return variations
    })



    // без вордпресса никуда
    const ajaxurl = '../wp-admin/admin-ajax.php'





    // закидываем продукт в корзину и переходим на страницу чекаута
    $(document.body).on("click", ".js-addToCart", function(e) {
        e.preventDefault()

        const postID = $(".product").attr("data-product-id")
        let productQuantity = $("body").find(".js-quantity_input").val()
        if (typeof variations === "string"){
            variations = variations.split(",")
        }

        $.ajax({
            url: ajaxurl,
            type: 'POST',
            async: true,
            data: {
                id: '',
                quantity: Number(productQuantity),
                variation: variations,
                title: '',
                post_id: Number(postID),
                shipping: 'standard',
                action: 'ads_actions_basket',
                ads_actions: 'add',
                discount: '',
            },
            success: function (data) {
                console.log(data)
                setTimeout(window.location.href='/cart', 3000)
            }
        });
    })

});